// extracted by mini-css-extract-plugin
module.exports = {"TestRoom":"_3TxPI65txVZXtPYHRKSPTF","LeftColumn":"ccp56CX65HG2mA703bcED","RightColumn":"_29nkTjrqgZuglmKxRsQ5Yl"};